import { Button, Checkbox, Divider, Form, Input, Select } from "antd";
import FormItem from "antd/es/form/FormItem";
import React, { useEffect, useState } from "react";

export default function LinkEditor(props) {

    const { onChange = () => { } } = props;
    const [loading, setLoading] = useState();
    const [type, setType] = useState("url");
    const [protocol, setProtocol] = useState("https://"); 

    useEffect(() => {
        setLoading(false);
    })

    if (loading) { return (<></>) }

    const emailValidator = (_, value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject();
    };

    const phoneValidator = (_, value) => {
        const phoneRegex = /^\+?(\d{1,3})?[-.\s]?(\d{1,4})?[-.\s]?(\d{1,4})[-.\s]?(\d{1,9})$/;
        if (phoneRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject();
    };

    const urlValidator = (_, value) => {
        var urlPattern = /^([a-zA-Z0-9_-]*\.)?[a-zA-Z0-9_-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?([\/?].*)?$/;

        if (urlPattern.test(value)) {
          return Promise.resolve();
        }
        return Promise.reject();
      };

    const selectURL = (
        <Select onChange={(e) => setProtocol(e)} style={{ "width": "90px" }} defaultValue="https://" className="select-before">
             <Select.Option value="https://">https://</Select.Option>
            <Select.Option value="http://">http://</Select.Option>
        </Select>
    )

    const selectEmail = (
        <Select style={{ "width": "90px" }} defaultValue="mailto:" className="select-before">
            <Select.Option value="mailto:">mailto:</Select.Option>
        </Select>
    )

    const selectPhone = (
        <Select style={{ "width": "90px" }} defaultValue="tel:" className="select-before">
            <Select.Option value="tel:">tel:</Select.Option>
        </Select>
    )


    const insertLink = (_f) => {
        let obj = {..._f};

        switch(type){
            case "url":
                obj.protocol = protocol;
            break; 
            case "email":
                obj.protocol = "mailto:";
            break; 
            case "phone":
                obj.protocol = "tel:";
            break; 
            default:
                obj.protocol = "mailto:";
            break; 
        }
        
        onChange(obj);
    }

    return (
        <>
            <Form onFinish={(_f) => insertLink(_f)} layout="vertical" >
                <Form.Item initialValue={type} name="type" label="Link type">
                    <Select onChange={(e) => setType(e)} value={type}>
                        <Select.Option key="url" value="url" >URL</Select.Option>
                        <Select.Option key="email" value="email">Email</Select.Option>
                        <Select.Option key="phone" value="phone">Phone Number</Select.Option>
                    </Select>
                </Form.Item>
                {((type === "url") &&
                    <>
                        <Form.Item rules={[{required: true, message: 'Please enter a URL', validator : urlValidator}]} initialValue="" name="url" label="URL">
                            <Input  addonBefore={selectURL} defaultValue="mysite" />
                        </Form.Item>
                        <Form.Item valuePropName="checked" initialValue={true} name="tab" noStyle>
                            <Checkbox>Open in a new tab?</Checkbox>
                        </Form.Item>
                    </>
                )}
                {((type === "email") &&
                    <Form.Item rules={[{required: true, message: 'Please enter email address', validator : emailValidator}]} initialValue="" name="email" label="Email address">
                        <Input addonBefore={selectEmail} defaultValue="mysite" />
                    </Form.Item>
                )}
                  {((type === "phone") &&
                    <Form.Item rules={[{required: true, message: 'Please enter phone number', validator : phoneValidator}]} initialValue="" name="phone" label="Phone number">
                        <Input addonBefore={selectPhone} defaultValue="mysite" />
                    </Form.Item>
                )}
                <Divider dashed />
                <div className="float-flex">
                    <div>&nbsp;</div>
                    <Button htmlType="submit" type="primary">Insert</Button>
                </div>
            </Form>
        </>
    )
}